import * as React from 'react';

import JobTabs from '../../../components/Hr/JobTabs';

// The feature component (JobPositions) owns the page title, so this stays a thin passthrough.
export default function JobPage(): React.JSX.Element {
    return <JobTabs/>;
}
